import { useServiceError } from '@/hooks';
import { useMutation } from 'react-query';
import {
  generateFinancialTrialBalance,
  generateFinancialCashFlow,
} from './Financial.service';
import {
  FinancialTrialBalance,
  FinancialCashFlowRequest,
} from './Financial.types';
import { notification } from 'antd';
import reportNotificationError from '@/utils/functions/notificationErrorNetReport';

export function useFinancialTrialBalance() {
  const mutation = useMutation(
    (obj: FinancialTrialBalance) => generateFinancialTrialBalance(obj),
    {
      onSuccess() {
        notification.success({
          message: 'Sucesso',
          description: 'Relatório do Balancete gerado com sucesso!',
        });
      },

      onError(error) {
        reportNotificationError(error);
      },
    },
  );

  return mutation;
}

export function useFinancialCashFlow() {
  const mutation = useMutation(
    (obj: FinancialCashFlowRequest) => generateFinancialCashFlow(obj),
    {
      onSuccess() {
        notification.success({
          message: 'Sucesso',
          description: 'Relatório do Fluxo de Caixa gerado com sucesso!',
        });
      },
    },
  );

  useServiceError(mutation.error);

  return mutation;
}
